module.exports = __webpack_public_path__ + "static/media/54-iveco-mercedes.bfbd20fa.jpg";